import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  300: { name: 'Bathroom Installation' },
  301: { name: 'Bathroom Refurbishment' },
  302: { name: 'Full Kitchen Installation' },
  303: { name: 'Kitchen Refurbishment' },
  304: { name: 'Vanity & Sanitaryware Installation' },
  305: { name: 'Washrooms' },
  306: { name: 'Wet Rooms' },
};

const AdminKitchensBathroomsPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Kitchens & Bathrooms Pricing Rules"
    description="Manage pricing for 7 kitchen and bathroom services"
  />
);

export default AdminKitchensBathroomsPricingRules;
